"use client";
import { useState } from "react";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import { ALL, DELIVERY, PICKUP } from "../..//lib";
import SkeletonLoader from "../SkeletonLoader";
import { useGoogleMaps } from "../../providers/GoogleMapProvider";

const containerStyle = {
  width: "100%",
  height: "600px",
};

export default function StoreLocationsMap({
  zoom,
  channel,
  markers,
  deliveryMarkers,
  pickupMarkers,
  initialMapCenter,
}: any) {
  const [selectedMarker, setSelectedMarker] = useState<any>(null);

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) throw new Error("Google Maps API key is missing");

  const { isLoaded } = useGoogleMaps();

  const getCurrentMarkers = () => {
    if (channel === ALL) return markers;
    if (channel === DELIVERY) return deliveryMarkers;
    if (channel === PICKUP) return pickupMarkers;
  };

  if (!isLoaded) return <SkeletonLoader />;
  console.log("initialMapCenter", initialMapCenter);
  return (
    <div className="store-map-item-remove">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={{
          lat: initialMapCenter?.[1] || 25.03528244630005,
          lng: initialMapCenter?.[0] || 67.1405685813624,
        }}
        zoom={zoom}
        options={{ disableDefaultUI: false }}
      >
        {getCurrentMarkers().map((marker: any, idx: number) => (
          <Marker
            key={idx}
            position={{
              lat: marker.coordinates.lat,
              lng: marker.coordinates.lng,
            }}
            onClick={() => setSelectedMarker(marker)}
            icon={{
              url: "/pin-red.png",
              scaledSize: new google.maps.Size(30, 40),
            }}
          />
        ))}

        {selectedMarker && (
          <InfoWindow
            position={{
              lat: selectedMarker.coordinates.lat,
              lng: selectedMarker.coordinates.lng,
            }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div
              style={{ fontSize: "14px", maxWidth: "200px", color: "black" }}
            >
              <strong>{selectedMarker.markerPopupName}</strong>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
}
